import { createSlice } from '@reduxjs/toolkit';
import _isEqual from 'lodash/isEqual';
import { getOnlyPageBodyByInitiativeId, setInititativeSettings } from './helper';

const isAdminMode = (initiativeId) => _isEqual(initiativeId, 'admin');
const urlSearchParams = new URLSearchParams(window?.location?.search);

const getInitialOrganizationId = () => {
  const organizationId = urlSearchParams.get('organization_id');
  if (organizationId) {
    sessionStorage.setItem('organization_id', organizationId);
  }
  return sessionStorage.getItem('organization_id') || null;
};

const getInitialInitiativeId = () => {
  const initiativeId = urlSearchParams.get('initiative_id');
  if (initiativeId) {
    sessionStorage.setItem('initiative_id', initiativeId);
  }
  return String(sessionStorage.getItem('initiative_id')) || '0';
};

const name = 'globalSelections';

const initialState = {
  initiatives: [],
  organizations: [],
  organizationId: getInitialOrganizationId(),
  initiativeId: getInitialInitiativeId(),
  adminMode: sessionStorage.getItem('initiative_id') === 'admin',
  error: null,
  initiativesOnLoading: true,
  organizationsOnLoading: false,
  refetchCurrentPageData: 0,
  initiativeSettings: null,
  isMainDataLoaded: false,
  bodyPageOnly: 0,
};

const globalSelections = createSlice({
  name,
  initialState,
  reducers: {
    getInitiativesRequest: (state) => {
      state.initiativesOnLoading = true;
    },
    getInitiativesSuccess: (state, { payload }) => {
      state.initiatives = payload.initiatives;
      state.initiativesOnLoading = false;
      state.isMainDataLoaded = true;
    },
    getInitiativesFailure: (state, { payload }) => {
      state.initiativesOnLoading = false;
      state.error = payload.error;
      state.isMainDataLoaded = true;
    },
    getOrganizationsRequest: (state) => {
      state.organizationsOnLoading = true;
    },
    getOrganizationsSuccess: (state, { payload }) => {
      state.organizations = payload.organizations;
      state.organizationsOnLoading = false;
    },
    getOrganizationsFailure: (state, { payload }) => {
      state.organizationsOnLoading = false;
      state.error = payload.error;
    },
    setInitiativeId: (state, { payload }) => {
      const isAdmin = isAdminMode(payload.initiativeId);
      state.initiativeId = payload.initiativeId;
      state.organizationId = null;
      state.organizations = [];
      if (state.adminMode || isAdmin) {
        state.refetchCurrentPageData = Number(!state.refetchCurrentPageData);
      }
      state.adminMode = isAdmin;
      state.bodyPageOnly = isAdmin
        ? 0
        : getOnlyPageBodyByInitiativeId(payload.initiativeId, state.initiatives);
      state.error = payload.error;
    },
    setOrganizationId: (state, { payload }) => {
      state.organizationId = payload.organizationId;
      state.refetchCurrentPageData = Number(!state.refetchCurrentPageData);
      state.initiativeSettings = setInititativeSettings(
        payload.organizationId,
        state.organizations,
      );
      state.error = payload.error;
    },
  },
});

export const { actions, reducer } = globalSelections;

export default reducer;
